"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedArticles = void 0;
var React = require("react");
var styles_1 = require("@/pages/articleDetail/components/RelatedArticles/styles");
var RelatedArticleItem_1 = require("@/pages/articleDetail/components/RelatedArticleItem/RelatedArticleItem");
exports.RelatedArticles = function (_a) {
    var newsAndInsights = _a.newsAndInsights, languageCode = _a.languageCode;
    var items = newsAndInsights.newsAndInsights, translate = newsAndInsights.translate;
    var youMayAlsoLike = translate.youMayAlsoLike, moreInsights = translate.moreInsights;
    var renderItems = function () { return (items.map(function (item) { return (React.createElement(RelatedArticleItem_1.RelatedArticleItem, { key: item.templateId, articleItem: item, translate: translate })); })); };
    return (React.createElement(styles_1.Container, null,
        React.createElement(styles_1.Title, null, youMayAlsoLike),
        renderItems(),
        React.createElement(styles_1.Link, { href: "/" + languageCode + "/property-news" },
            React.createElement(styles_1.MoreContainer, null, moreInsights))));
};
